export default __webpack_public_path__ + "static/media/Middel 6.b30dced5.svg";